// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picto[data-v-77a1be50]{max-width:50px;min-width:30px;margin:3px}.active-picto .picto[data-v-77a1be50]{border:3px solid orange}", ""]);
// Exports
module.exports = exports;
